import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const allDisciplines = [
  { key: 'kite', text: 'Kitefoil' },
  { key: 'wing', text: 'Wingfoil' },
  { key: 'wind', text: 'Windfoil' },
  { key: 'surf', text: 'Surf foil' },
  { key: 'pump', text: 'Pumping' },
  { key: 'dw', text: 'Downwind' },
  { key: 'sup', text: 'SUP foil' },
];

const allProducts = {
  // FOIL KITS --------------------------
  foil_kits: [
    {
      name: 'SABFOIL Glider Blackbird - Blade 700-377',
      price: 989,
      in_stock: false,
      image: require('@/assets/images/products/2026/gb-700-377bb.jpg'),
      description: 'Blackbird Blade 700-377 hydrofoil Glider set. Hydrofoil Blackbird in full carbon for freerace and performance. Includes Blade 700 BB front wing and Blade 377 BB stabilizer.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'WB700/BB' },
        { txt: 'SB377/BB' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird - Balz Pro 805-365',
      price: 979,
      deal_price: 879,
      in_stock: true,
      image: require('@/assets/images/products/2026/gbz-805-365bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRO 805 BB front wing and Progressive 365 BB stabilizer. Early lift, high speed, razor-sharp control.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ805/BB' },
        { txt: 'SP365/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird - Balz Pro 905-385',
      price: 989,
      deal_price: 889,
      in_stock: true,
      image: require('@/assets/images/products/2026/gbz-905-385bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRo 905 BB front wing and Progressive 385 BB stabilizer. Early lift, high speed, razor-sharp control.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ905/BB' },
        { txt: 'SP385/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird - Balz Pro 965-385',
      price: 999,
      deal_price: 899,
      in_stock: true,
      image: require('@/assets/images/products/2026/gbz-965-385bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRO 965 BB front wing and Progressive 385 BB stabilizer. Early lift, high speed, razor-sharp control.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ965/BB' },
        { txt: 'SP385/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird Razor 847-345',
      price: 979,
      in_stock: false,
      image: require('@/assets/images/products/2026/gr-847-345bb.jpg'),
      description: 'Blackbird Razor 847-345 hydrofoil Glider set - Blackbird full carbon set with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR847/BB' },
        { txt: 'SP345/BB' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird Razor 977-375',
      price: 989,
      deal_price: 890,
      in_stock: true,
      image: require('@/assets/images/products/2026/gr-977-375bb.jpg'),
      description: 'Blackbird Razor 977-375 hydrofoil Glider set - Blackbird full carbon set with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR977/BB' },
        { txt: 'SDW375/BB' },
      ],
    },
    {
      name: 'SABFOIL Glider Blackbird Razor 1077-375',
      price: 999,
      deal_price: 899,
      in_stock: true,
      image: require('@/assets/images/products/2026/gr-1077-375bb.jpg'),
      description: 'Blackbird Glider Set 1077-375 Razor. High-aspect Razor 1077 front wing and 375 stabilizer. Designed for wing, downwind, and SUP foiling. Ultra-efficient, fast, and stable for long glides and powerful pumping.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WR1077/BB' },
        { txt: 'SDW375/BB' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Balz Pro 805 / Mast 85',
      price: 1869,
      deal_price: 1679,
      in_stock: true,
      image: require('@/assets/images/products/2026/kbz-805-365-85bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRo 805 BB front wing, Progressive 365 BB stabilizer and 85 BBmast with UHM W-core. Early lift, high speed, razor-sharp control.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ805/BB' },
        { txt: 'SP365/BB' },
        { txt: 'M85/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Balz Pro 905 / Mast 85',
      price: 1879,
      deal_price: 1689,
      in_stock: true,
      image: require('@/assets/images/products/2026/kbz-905-385-85bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRo 905 BB front wing, Progressive 385 BB stabilizer and 85 BBmast with UHM W-core. Early lift, high speed, razor-sharp control.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ905/BB' },
        { txt: 'SP385/BB' },
        { txt: 'M85/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Balz Pro 965 / Mast 85',
      price: 1889,
      deal_price: 1699,
      in_stock: true,
      image: require('@/assets/images/products/2026/kbz-965-385-85bb.jpg'),
      description: 'Sabfoil Blackbird hydrofoil set - Balz Müller Pro model. Blackbird full carbon set developed with Balz Müller for freestyle, wave and speed. Includes Balz PRO 965 BB front wing, Progressive 385 BB stabilizer and 85 BB mast with UHM W-core. Early lift, high speed, razor-sharp control.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ965/BB' },
        { txt: 'SP385/BB' },
        { txt: 'M85/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Blade 700 / Mast 110',
      price: 1879,
      in_stock: false,
      image: require('@/assets/images/products/2026/kb-700-377-110bb.jpg'),
      description: 'Blackbird Blade 700-377-110 hydrofoil complete set. Blackbird full carbon set. Includes Blade 700 BB front wing, Blade 377 BB stabilizer, and 110 BB mast with UHM W-core.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'WB700/BB' },
        { txt: 'SB377/BB' },
        { txt: 'M110/BB' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Razor 847 / Mast 75',
      price: 1879,
      in_stock: false,
      image: require('@/assets/images/products/2026/kr-847-345-75bb.jpg'),
      description: 'Blackbird Razor 847-345-75 hydrofoil complete set. Blackbird full carbon set with high-aspect front wing offering exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR847/BB' },
        { txt: 'S345/BB' },
        { txt: 'M75/BB' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Razor 977 / Mast 75',
      price: 1889,
      deal_price: 1700,
      in_stock: true,
      image: require('@/assets/images/products/2026/kr-977-375-75bb.jpg'),
      description: 'Blackbird Razor 977-375-75 hydrofoil complete set. Blackbird full carbon set with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR977/BB' },
        { txt: 'S375/BB' },
        { txt: 'M75/BB' },
      ],
    },
    {
      name: 'SABFOIL Kit Blackbird Razor 1077 / Mast 75',
      price: 1899,
      deal_price: 1709,
      in_stock: true,
      image: require('@/assets/images/products/2026/kr-1077-375-75bb.jpg'),
      description: 'Blackbird Razor 1077-375-75 complete foil set. High-aspect set with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WR1077/BB' },
        { txt: 'S375/BB' },
        { txt: 'M75/BB' },
      ],
    },
    {
      name: 'SABFOIL Kit M101-W671-S399-FK647',
      price: 2049,
      deal_price: 922,
      in_stock: true,
      image: require('@/assets/images/products/kit_101-671-399-647.jpg'),
      description: 'Un foil de freerace accessible qui permet d’aller vraiment vite.',
      disciplines: ['kite'],
      details: [
        { txt: 'M101' },
        { txt: 'W671 (570cm2)' },
        { txt: 'S399 (207cm2)' },
        { txt: 'FK647' },
      ],
    },
    {
      name: 'SABFOIL Kit BALZ PRO 707-663-325/83',
      price: 1529,
      in_stock: false,
      image: require('@/assets/images/products/2025/balz707-663-32583.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'BALZ/MK83' },
        { txt: 'BALZ/W707' },
        { txt: 'SF/325' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Balz PRO 707-663-325',
      price: 719,
      in_stock: false,
      image: require('@/assets/images/products/2025/balz707-663-325-gld.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/W707' },
        { txt: 'SF/325' },
        { txt: 'F663K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Medusa PRO 769-663-375/83',
      price: 1489,
      in_stock: false,
      image: require('@/assets/images/products/2025/kmp769-663-37583.jpg'),
      description: 'The Medusa PRO line is ideal for Kitefoil or Wingfoil, excelling in Power Freestyle sessions and wave riding. It features superior acceleration and high top speeds.',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'MK/83' },
        { txt: 'WMP/769' },
        { txt: 'SR/375' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Kit BALZ PRO 808-663-370/83',
      price: 1549,
      deal_price: 1239,
      in_stock: true,
      image: require('@/assets/images/products/2025/balz808-663-37083.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/MK83' },
        { txt: 'BALZ/W808' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Balz PRO 808-663-370',
      price: 739,
      deal_price: 591,
      in_stock: true,
      image: require('@/assets/images/products/2025/balz808-663-370-gld.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/W808' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Sea Devil 840 - 2122cm2',
      price: 799,
      in_stock: false,
      image: require('@/assets/images/products/2025/wsd840.jpg'),
      description: '2-in-1 foil for high-performance in light to medium wind. Stability and control with stabilizer, agility and instant response without. Self-stabilizing profile, full carbon monocoque construction. Compact, fast, radical.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'SD840' },
        { txt: 'Surface 2122cm2' },
        { txt: 'Span 840mm' },
        { txt: 'Chord 520mm' },
        { txt: 'Aspect ratio 3,3' },
        { txt: 'Connection type Monocoque' },
      ],
    },
    {
      name: 'SABFOIL Sea Devil 840 USED - 2122cm2',
      price: 799,
      in_stock: true,
      used: true,
      deal_price: 559,
      image: require('@/assets/images/products/2025/wsd840.jpg'),
      description: '2-in-1 foil for high-performance in light to medium wind. Stability and control with stabilizer, agility and instant response without. Self-stabilizing profile, full carbon monocoque construction. Compact, fast, radical.' +
      '<b> Used glider in excellent condition, like new! </b>',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'SD840' },
        { txt: 'Surface 2122cm2' },
        { txt: 'Span 840mm' },
        { txt: 'Chord 520mm' },
        { txt: 'Aspect ratio 3,3' },
        { txt: 'Connection type Monocoque' },
      ],
    },
    {
      name: 'SABFOIL Kit Medusa PRO 869-663-395/83',
      price: 1489,
      in_stock: false,
      image: require('@/assets/images/products/2025/kmp869-663-39583.jpg'),
      description: 'The Medusa PRO line is perfect for Wingfoil, excelling in Power Freestyle sessions and wave riding. It features superior acceleration and high top speeds.',
      disciplines: ['wing'],
      details: [
        { txt: 'MK/83' },
        { txt: 'WMP/869' },
        { txt: 'SR/395' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Kit BALZ PRO 909-663-370/83',
      price: 1569,
      in_stock: false,
      image: require('@/assets/images/products/2025/balz909-663-37083.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/MK83' },
        { txt: 'BALZ/W909' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Balz PRO 909-663-370',
      price: 749,
      deal_price: 599,
      in_stock: true,
      image: require('@/assets/images/products/2025/balz909-663-370-gld.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/W909' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit BALZ PRO 969-663-370/83',
      price: 1589,
      in_stock: false,
      image: require('@/assets/images/products/2025/balz969-663-37083.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'BALZ/MK83' },
        { txt: 'BALZ/W969' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Razor PRO 975-653-370',
      price: 719,
      deal_price: 575,
      in_stock: true,
      image: require('@/assets/images/products/2025/krp975-653-370gld.jpg'),
      description: 'The Razor PRO 975 is versatile for medium to low wave conditions, offering high performance and facilitating pumping. It features lightning-fast response and tighter turns.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WRP/975' },
        { txt: 'SF/370' },
        { txt: 'F653K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Sea Devil 1040 - 2445cm2',
      price: 799,
      in_stock: false,
      image: require('@/assets/images/products/2025/wsd1040.jpg'),
      description: '2-in-1 foil for high-performance in light to medium wind. Stability and control with stabilizer, agility and instant response without. Self-stabilizing profile, full carbon monocoque construction. Compact, fast, radical.',
      disciplines: ['wing', 'wind', 'sup', 'dw'],
      details: [
        { txt: 'SD1040' },
        { txt: 'Surface 2445cm2' },
        { txt: 'Span 1040mm' },
        { txt: 'Chord 520mm' },
        { txt: 'Aspect ratio 4,42' },
        { txt: 'Connection type Monocoque' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan PRO 1160-663-370/84RD',
      price: 1499,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1160-663-37084rd.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1160 with the ultra high-modulus R8 Red Devil 84 mast. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['wing', 'dw'],
      details: [
        { txt: 'MK/84RD' },
        { txt: 'WLP/1160' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Leviathan PRO 1160-663-370',
      price: 759,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1160-663-370gld.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1160. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['wing', 'dw'],
      details: [
        { txt: 'WLP/1160' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan PRO 1260-663-370/84RD',
      price: 1519,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1260-663-37084rd.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1260 with the ultra high-modulus R8 74 mast. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'MK/84RD' },
        { txt: 'WLP/1260' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Leviathan PRO 1260-663-370',
      price: 779,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1260-663-370gld.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1260. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WLP/1260' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan 1350-663-370/73P',
      price: 1499,
      in_stock: false,
      image: require('@/assets/images/products/2025/kl1350-663-37073p.jpg'),
      description: 'This hydrofoil set is designed for low winds and swells, offering great performance and versatility for downwind sessions. It includes a high aspect ratio front wing, a stiff mast, and a flat stabilizer.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'MK/73P' },
        { txt: 'WL/1350' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Leviathan 1350-663-370',
      price: 769,
      in_stock: false,
      image: require('@/assets/images/products/2025/kl1350-663-370gld.jpg'),
      description: 'This hydrofoil glider is designed for low winds and swells, offering great performance and versatility for downwind sessions. It includes a high aspect ratio front wing and a flat stabilizer.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'WL/1350' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and Titanium Quick Release System (Q02K) included' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan PRO 1360-663-370/84RD',
      price: 1549,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1360-663-37084rd.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1360 with the ultra high-modulus R8 74 mast. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'MK/84RD' },
        { txt: 'WLP/1360' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'CP02K/Ti' },
        { txt: 'Bag and Q02K included' },
      ],
    },
    {
      name: 'SABFOIL Glider Leviathan PRO 1360-663-370',
      price: 799,
      in_stock: false,
      image: require('@/assets/images/products/2025/klp1360-663-370gld.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, featuring Leviathan PRO 1360. Built to win downwind and pump races, it offers pure speed and gliding pleasure.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'WLP/1360' },
        { txt: 'SF/370' },
        { txt: 'F663K' },
        { txt: 'Bag and Titanium Quick Release System (Q02K) included' },
      ],
    },
  ],
  // BOARDS -----------------------------
  boards: [
    {
      name: 'SABFOIL Board B08 Carbon - 8L',
      price: 819,
      deal_price: 573,
      in_stock: true,
      image: require('@/assets/images/products/board_b08.jpg'),
      description: 'Super compacte pour le pumping et le kite strapless. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['pump'],
      details: [
        { txt: 'B08' },
        { txt: '90cm x 38,9cm x 3cm' },
        { txt: '8 L' },
      ],
    },
    {
      name: 'SABFOIL Pump 8L Compact Foilboard',
      price: 749,
      in_stock: false,
      image: require('@/assets/images/products/2025/bpump08.jpg'),
      description: 'The B08 is a super stiff and compact board, enjoyable and very easy to carry. It is the ideal choice for your Pump and Dock-Start sessions.',
      disciplines: ['pump'],
      details: [
        { txt: 'Volume: 8 L' },
        { txt: 'Length: 2’9’’ / 899 mm' },
        { txt: 'Width: 15,28’’ / 388 mm' },
        { txt: 'Thickness: 1,18’’ / 30 mm' },
      ],
    },
    {
      name: 'SABFOIL Kite 14L Foilboard',
      price: 999,
      in_stock: false,
      image: require('@/assets/images/products/2025/bkite14.jpg'),
      description: 'The B14 is a lightweight, agile, and practical kite board, designed for both Freestyle and Freeride use.',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'Volume: 14 L' },
        { txt: 'Length: 3’5’’ / 1080 mm' },
        { txt: 'Width: 17,71’’ / 450 mm' },
        { txt: 'Thickness: 1,57’’ / 40 mm' },
      ],
    },
    {
      name: 'SABFOIL Board B21 Carbon - 21 L',
      price: 1019,
      deal_price: 611,
      in_stock: true,
      image: require('@/assets/images/products/board_b21.jpg'),
      description: 'Planche très polyvalente et compacte, pour les riders qui recherchent un peu plus de volume que celui offert par la B14.',
      disciplines: ['kite'],
      details: [
        { txt: 'B21' },
        { txt: '128cm x 45,5cm x 5cm' },
        { txt: '21 L' },
      ],
    },
    {
      name: 'SABFOIL Kite 21L Foilboard',
      price: 1149,
      in_stock: false,
      image: require('@/assets/images/products/2025/bkite21.jpg'),
      description: 'The B21 is a lightweight, agile, and practical kite board, designed for both Freestyle and Freeride use.',
      disciplines: ['kite'],
      details: [
        { txt: 'Volume: 21 L' },
        { txt: 'Length: 4’2’’ / 1280 mm' },
        { txt: 'Width: 17,71’’ / 450 mm' },
        { txt: 'Thickness: 1,96’’ / 50 mm' },
      ],
    },


  ],
  // WINGS ------------------------------
  wings: [
    {
      name: 'SABFOIL Wing Blackbird Blade 700',
      price: 709,
      in_stock: false,
      image: require('@/assets/images/products/2026/wb700bb.jpg'),
      description: 'Blackbird Front Wing 700 Blade. High-performance front wing designed for speed and agility. Perfect for freestyle and wave riding, offering razor-sharp control and early lift.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'WB700/BB' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird 805 - Balz Pro',
      price: 699,
      deal_price: 629,
      in_stock: true,
      image: require('@/assets/images/products/2026/wbz805bb.jpg'),
      description: 'Full carbon wing designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ805/BB' },
        { txt: 'Surface 792cm2' },
        { txt: 'Span 805mm' },
        { txt: 'Root chord 143mm' },
        { txt: 'Aspect ratio 8.3' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird 905 - Balz Pro',
      price: 709,
      deal_price: 638,
      in_stock: true,
      image: require('@/assets/images/products/2026/wbz905bb.jpg'),
      description: 'Full carbon wing designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ905/BB' },
        { txt: 'Surface 998cm2' },
        { txt: 'Span 905mm' },
        { txt: 'Root chord 161mm' },
        { txt: 'Aspect ratio 8.3' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird 965 - Balz Pro',
      price: 719,
      deal_price: 647,
      in_stock: true,
      image: require('@/assets/images/products/2026/wbz965bb.jpg'),
      description: 'Full carbon wing designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'WBZ965/BB' },
        { txt: 'Surface 1210cm2' },
        { txt: 'Span 965mm' },
        { txt: 'Root chord 186mm' },
        { txt: 'Aspect ratio 8.3' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird Razor 847',
      price: 709,
      in_stock: false,
      image: require('@/assets/images/products/2026/wr847bb.jpg'),
      description: 'Blackbird Front Wing 847 Razor. High-aspect front wing with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR847/BB' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird Razor 977',
      price: 719,
      deal_price: 647,
      in_stock: true,
      image: require('@/assets/images/products/2026/wr977bb.jpg'),
      description: 'Blackbird Front Wing 977 Razor. High-aspect front wing with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'WR977/BB' },
      ],
    },
    {
      name: 'SABFOIL Wing Blackbird Razor 1077',
      price: 729,
      deal_price: 656,
      in_stock: true,
      image: require('@/assets/images/products/2026/wr1077bb.jpg'),
      description: 'Blackbird Front Wing 1077 Razor. High-aspect front wing with exceptional glide, unmatched pumpability, and top-tier performance for downwind and prone surf. Smooth, fast, and endlessly efficient.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WR1077/BB' },
      ],
    },
    {
      name: 'MOSES Wing 558 - 550cm2',
      price: 342,
      deal_price: 171,
      deals_only: true,
      in_stock: true,
      image: require('@/assets/images/products/wing_558n.jpg'),
      description: 'Une aile all round très performante, rapide, et pour sauter haut!',
      disciplines: ['kite'],
      details: [
        { txt: 'W558' },
        { txt: 'Surface 550cm2' },
        { txt: 'Span 558mm' },
        { txt: 'Chord 120mm' },
        { txt: 'Aspect ratio 6,3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 590Y - 650cm2',
      price: 459,
      deal_price: 229,
      in_stock: true,
      image: require('@/assets/images/products/wing_590.jpg'),
      description: 'L’aile à tout faire qui conviendra aussi bien au débutant qu’à l’expert. \n Stable et rapide, elle offre un bon lift et des belles performances. Certifiée IKA Youth Foil Class.',
      disciplines: ['kite'],
      details: [
        { txt: 'W590Y' },
        { txt: 'Surface 650cm2' },
        { txt: 'Span 590mm' },
        { txt: 'Chord 132mm' },
        { txt: 'Aspect ratio 5,2' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 633 M6 - 1250cm2',
      price: 449,
      deal_price: 224,
      in_stock: true,
      image: require('@/assets/images/products/wing_633.jpg'),
      description: 'Très fun, la W633 permet aussi bien de tourner sur place à très basse vitesse que de s’offrir une session de carving radical dans un vent soutenu! \n \n ' +
      'Compatible uniquement avec les fuselages FS710 et FW900',
      disciplines: ['kite'],
      details: [
        { txt: 'W633' },
        { txt: 'Surface 1250cm2' },
        { txt: 'Span 633mm' },
        { txt: 'Chord 256mm' },
        { txt: 'Aspect ratio 3,3' },
        { txt: 'Connection type: big chord, M6 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 669 - 548cm2',
      price: 379,
      deal_price: 284,
      in_stock: true,
      image: require('@/assets/images/products/WMP669_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 669 est meilleure en wing et kite dans des conditions de vent fort. Très gros lift pour sa surface.',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'WMP669' },
        { txt: 'Surface 548cm2' },
        { txt: 'Span 669mm' },
        { txt: 'Chord 120mm' },
        { txt: 'Aspect ratio 8,14' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 669 548cm2',
      price: 379,
      in_stock: false,
      image: require('@/assets/images/products/2025/wmp669.jpg'),
      description: 'The Medusa PRO line is designed for superior acceleration and high top speeds. Ideal for Power Freestyle sessions and advanced aerial maneuvers.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'Surface: 548 cm2' },
        { txt: 'AR: 8,14' },
        { txt: 'Wingspan: 669 mm' },
        { txt: 'Volume: 424 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 671 PF - 570cm2',
      price: 479,
      deal_price: 311,
      in_stock: true,
      image: require('@/assets/images/products/WB671-PF_A.jpg'),
      description: 'Une aile très performante. Son profil fin permet une vitesse élevée et un carving agressif. \n Une pure aile de race, mais très accessible et polyvalente.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'W671/PF' },
        { txt: 'Surface 570cm2' },
        { txt: 'Volume 373cm3' },
        { txt: 'Span 670mm' },
        { txt: 'Chord 115mm' },
        { txt: 'Aspect ratio 7,8' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 680 - 631cm2',
      price: 469,
      deal_price: 234,
      in_stock: true,
      image: require('@/assets/images/products/wing_R680.jpg'),
      description: 'Une aile rapide et maniable. Bonne glisse et portance pour sa petite surface.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR680' },
        { txt: 'Surface 550cm2' },
        { txt: 'Volume 457cm3' },
        { txt: 'Span 680mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 8,40' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 695 - 770cm2',
      price: 469,
      deal_price: 234,
      in_stock: true,
      image: require('@/assets/images/products/wing_695.jpg'),
      description: 'Vitesse, maniabilité, capacité à sauter haut, polyvalence: une aile très aboutie.',
      disciplines: ['kite'],
      details: [
        { txt: 'W695' },
        { txt: 'Surface 770cm2' },
        { txt: 'Span 695mm' },
        { txt: 'Chord 131mm' },
        { txt: 'Aspect ratio 6,3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 700 USED - 552cm2',
      price: 379,
      deal_price: 265,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/2025/WB700.jpg'),
      description: 'High-performance freerace front wing. Thin profile, high aspect ratio, and instant response for experienced riders seeking speed, control, and precision in any condition. <b> Occasion en parfait état, comme neuve! <b>',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 552 cm2' },
        { txt: 'AR: 8,9' },
        { txt: 'Wingspan: 700 mm' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 700 - 552cm2',
      price: 379,
      deal_price: 303,
      in_stock: true,
      image: require('@/assets/images/products/2025/WB700.jpg'),
      description: 'High-performance freerace front wing. Thin profile, high aspect ratio, and instant response for experienced riders seeking speed, control, and precision in any condition.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 552 cm2' },
        { txt: 'AR: 8,9' },
        { txt: 'Wingspan: 700 mm' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 707 Balz Müller Limited',
      price: 399,
      deal_price: 319,
      in_stock: true,
      image: require('@/assets/images/products/2025/balzw707.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 661 cm2' },
        { txt: 'AR: 7,55' },
        { txt: 'Wingspan: 707 mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'MOSES Wing 718 - 740cm2',
      price: 468,
      deal_price: 187,
      in_stock: true,
      image: require('@/assets/images/products/wing_718.jpg'),
      description: 'Une aile de free race, super stable à haute vitesse et permettant de rester sur le foil à vitesse réduite.',
      disciplines: ['kite'],
      details: [
        { txt: 'W718' },
        { txt: 'Surface 740cm2' },
        { txt: 'Span 718mm' },
        { txt: 'Chord 134mm' },
        { txt: 'Aspect ratio 6,95' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },

      ],
    },
    {
      name: 'SABFOIL Wing 730 - 1050cm2',
      price: 479,
      deal_price: 239,
      in_stock: true,
      image: require('@/assets/images/products/wing_730.jpg'),
      description: 'Une aile pour surfer les vagues.',
      disciplines: ['wing', 'surf'],
      details: [
        { txt: 'W730' },
        { txt: 'Surface 1050cm2' },
        { txt: 'Volume 1295cm3' },
        { txt: 'Span 730mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,0' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },

    {
      name: 'SABFOIL Wing Blade 740 - 702cm2',
      price: 499,
      deal_price: 349,
      in_stock: true,
      image: require('@/assets/images/products/wing_B740.jpg'),
      description: 'Une aile pour aller très vite dans toutes les disciplines. Un beau lift et de la maniabilité à basse vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WB740' },
        { txt: 'Surface 702cm2' },
        { txt: 'Volume 447cm3' },
        { txt: 'Span 740mm' },
        { txt: 'Chord 130mm' },
        { txt: 'Aspect ratio 8,34' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 740 PF - 702cm2',
      price: 499,
      in_stock: false,
      image: require('@/assets/images/products/WB740-PF_A.jpg'),
      description: 'Une aile pour aller très vite dans toutes les disciplines. Un beau lift et de la maniabilité à basse vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WB740/PF' },
        { txt: 'Surface 702cm2' },
        { txt: 'Volume 447cm3' },
        { txt: 'Span 740mm' },
        { txt: 'Chord 130mm' },
        { txt: 'Aspect ratio 8,34' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 769 - 700cm2',
      price: 389,
      deal_price: 291,
      in_stock: true,
      image: require('@/assets/images/products/WMP769_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 769 est meilleure en wing, wind et kite dans des conditions de vent moyen à fort.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WMP769' },
        { txt: 'Surface 700cm2' },
        { txt: 'Span 769mm' },
        { txt: 'Chord 133,2mm' },
        { txt: 'Aspect ratio 8,44' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 769 700cm2',
      price: 389,
      in_stock: false,
      image: require('@/assets/images/products/2025/wmp769.jpg'),
      description: 'The Medusa PRO line is designed for superior acceleration and high top speeds. Ideal for Power Freestyle sessions and advanced aerial maneuvers.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 700 cm2' },
        { txt: 'AR: 8,44' },
        { txt: 'Wingspan: 769 mm' },
        { txt: 'Volume: 581 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 780 used - 631cm2',
      price: 489,
      deal_price: 171,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/wing_R780.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles pour sa petite surface. <b> Aile d’occasion en bon état. <b>',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR780' },
        { txt: 'Surface 631cm2' },
        { txt: 'Volume 546cm3' },
        { txt: 'Span 780mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 9,64' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 780 - 631cm2',
      price: 489,
      deal_price: 244,
      in_stock: true,
      image: require('@/assets/images/products/wing_R780.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles pour sa petite surface.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR780' },
        { txt: 'Surface 631cm2' },
        { txt: 'Volume 546cm3' },
        { txt: 'Span 780mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 9,64' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 799 PF - 1100cm2',
      price: 509,
      deal_price: 305,
      in_stock: true,
      image: require('@/assets/images/products/WM799-PF_A.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. \n Manoeuvrante et agile, parfaite pour le freestyle en wing.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WM799/PF' },
        { txt: 'Surface 1100cm2' },
        { txt: 'Volume 1174cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,8' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 800 - 840cm2',
      price: 509,
      deal_price: 254,
      in_stock: true,
      image: require('@/assets/images/products/wing_800.jpg'),
      description: 'Un design pour aller vite en wing, wind ou surf.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'W800' },
        { txt: 'Surface 840cm2' },
        { txt: 'Volume 565cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 129,5mm' },
        { txt: 'Aspect ratio 7,6' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 808 Balz Müller Limited',
      price: 419,
      deal_price: 335,
      in_stock: true,
      image: require('@/assets/images/products/2025/balzw808.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 792 cm2' },
        { txt: 'AR: 8,26' },
        { txt: 'Wingspan: 808 mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 820 - 746cm2',
      price: 499,
      deal_price: 249,
      in_stock: true,
      image: require('@/assets/images/products/wing_R820.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles, pumping facile.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR820' },
        { txt: 'Surface 746cm2' },
        { txt: 'Volume 636cm3' },
        { txt: 'Span 820mm' },
        { txt: 'Chord 112,4mm' },
        { txt: 'Aspect ratio 8,84' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 869 - 854cm2',
      price: 399,
      deal_price: 299,
      in_stock: true,
      image: require('@/assets/images/products/WMP869_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 869 est meilleure en wing et wind dans des conditions de vent faible à moyen, mais  également en kite par vent léger.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WMP869' },
        { txt: 'Surface 854cm2' },
        { txt: 'Span 869mm' },
        { txt: 'Chord 144mm' },
        { txt: 'Aspect ratio 8,84' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 869 854cm2',
      price: 399,
      in_stock: false,
      image: require('@/assets/images/products/2025/wmp869.jpg'),
      description: 'The Medusa PRO line is designed for superior acceleration and high top speeds. Ideal for Power Freestyle sessions and advanced aerial maneuvers.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 854 cm2' },
        { txt: 'AR: 8,84' },
        { txt: 'Wingspan: 869 mm' },
        { txt: 'Volume: 757 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 875 - 843cm2',
      price: 389,
      in_stock: false,
      image: require('@/assets/images/products/2025/wrp875.jpg'),
      description: 'The Razor PRO is designed to maximize performance in waves and ride faster downwind. It offers lightning-fast response and tighter turns.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'Surface: 843 cm2' },
        { txt: 'AR: 9,20' },
        { txt: 'Wingspan: 880 mm' },
        { txt: 'Volume: 775 cm3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 880 - 843cm2',
      price: 509,
      deal_price: 254,
      in_stock: true,
      image: require('@/assets/images/products/wing_R880.jpg'),
      description: 'Une aile qui décolle rapidement et offre une grande plage de vitesse. Sa maniabilité à bas régime et sa stabilité à haute vitesse la rendent très polyvalente. Belle glisse et portance par vent modéré.',
      disciplines: ['wing', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'WR880' },
        { txt: 'Surface 843cm2' },
        { txt: 'Volume 834cm3' },
        { txt: 'Span 880mm' },
        { txt: 'Chord 118mm' },
        { txt: 'Aspect ratio 9,2' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 909 Balz Müller Limited',
      price: 429,
      deal_price: 343,
      in_stock: true,
      image: require('@/assets/images/products/2025/balzw909.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 1000 cm2' },
        { txt: 'AR: 8,26' },
        { txt: 'Wingspan: 909 mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 950 - 1350cm2',
      price: 589,
      deal_price: 265,
      in_stock: true,
      image: require('@/assets/images/products/wing_950.jpg'),
      description: 'La petite soeur de la W1100, plus rapide et manoeuvrante, parfaite pour le freestyle et les runs de vitesse en wing',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'W950' },
        { txt: 'Surface 1350cm2' },
        { txt: 'Span 950mm' },
        { txt: 'Chord 185mm' },
        { txt: 'Aspect ratio 6,65' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 969 Balz Müller Limited',
      price: 449,
      in_stock: false,
      image: require('@/assets/images/products/2025/balzw969.jpg'),
      description: 'The Balz Pro Line is Balz Müller’s signature model for Sabfoil, designed for explosive acceleration and high top speeds. It excels in funboarding sessions with advanced aerial maneuvers and smooth, skaty carves.',
      disciplines: ['wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 1230 cm2' },
        { txt: 'AR: 7,80' },
        { txt: 'Wingspan: 969 mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 975 - 942cm2',
      price: 399,
      deal_price: 319,
      in_stock: true,
      image: require('@/assets/images/products/2025/wrp975.jpg'),
      description: 'The Razor PRO is designed to maximize performance in waves and ride faster downwind. It offers lightning-fast response and tighter turns.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'Surface: 942 cm2' },
        { txt: 'AR: 10,20' },
        { txt: 'Wingspan: 980 mm' },
        { txt: 'Volume: 860,5 cm3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan PRO 1060',
      price: 419,
      in_stock: false,
      image: require('@/assets/images/products/2025/wlp1060.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, designed for pure speed and gliding pleasure. Built to win downwind and pump races.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 947 cm2' },
        { txt: 'AR: 11,53' },
        { txt: 'Wingspan: 1060 mm' },
        { txt: 'Volume: 757 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 1075 - 1061cm2',
      price: 419,
      deal_price: 335,
      in_stock: true,
      image: require('@/assets/images/products/2025/wrp1075.jpg'),
      description: 'High-aspect-ratio front wing for Sabfoil hydrofoil, optimized for downwind, pumping and wing foil in light wind conditions. Early lift, continuous glide and high efficiency for advanced riders seeking performance when the wind drops.',
      disciplines: ['wing', 'pump', 'dw'],
      details: [
        { txt: 'Surface: 1061 cm2' },
        { txt: 'AR: 11,00' },
        { txt: 'Wingspan: 1075 mm' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 1110 USED - 1180cm2',
      price: 629,
      deal_price: 251,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/wing_1110.jpg'),
      description: 'Une aile rapide pour le wing. \n Elle offre aussi une vitesse et une glisse inégalée en pumping pour les experts. Occasion, état quasiment neuf.',
      disciplines: ['wing', 'pump'],
      details: [
        { txt: 'W1110' },
        { txt: 'Surface 1180cm2' },
        { txt: 'Span 1110mm' },
        { txt: 'Chord 132,6mm' },
        { txt: 'Aspect ratio 10,4' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1150',
      price: 389,
      deal_price: 291,
      in_stock: true,
      image: require('@/assets/images/products/2025/wl1150.jpg'),
      description: 'The Leviathan 1150 front wing offers quick starts and efficient rides for those trained in pumping and dock-start. It is also great for wingfoil and downwind in medium-low wind conditions.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 1580 cm2' },
        { txt: 'AR: 8,37' },
        { txt: 'Wingspan: 1150 mm' },
        { txt: 'Volume: 2071 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan PRO 1160',
      price: 439,
      in_stock: false,
      image: require('@/assets/images/products/2025/wlp1160.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, designed for pure speed and gliding pleasure. Built to win downwind and pump races.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 1083 cm2' },
        { txt: 'AR: 12,42' },
        { txt: 'Wingspan: 1160 mm' },
        { txt: 'Volume: 878 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan PRO 1260',
      price: 459,
      in_stock: false,
      image: require('@/assets/images/products/2025/wlp1260.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, designed for pure speed and gliding pleasure. Built to win downwind and pump races.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 1260 cm2' },
        { txt: 'AR: 12,93' },
        { txt: 'Wingspan: 1260 mm' },
        { txt: 'Volume: 983 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1350',
      price: 449,
      deal_price: 337,
      in_stock: true,
      image: require('@/assets/images/products/2025/wl1350.jpg'),
      description: 'The Leviathan 1350 front wing is versatile and high-performing, perfect for pumping and dock-start. It is also ideal for winging in low wind conditions and downwind rides.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 1870 cm2' },
        { txt: 'AR: 9,75' },
        { txt: 'Wingspan: 1350 mm' },
        { txt: 'Volume: 2423 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan PRO 1360',
      price: 489,
      in_stock: false,
      image: require('@/assets/images/products/2025/wlp1360.jpg'),
      description: 'Sabfoil\'s most radical downwind weapon, designed for pure speed and gliding pleasure. Built to win downwind and pump races.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 1400 cm2' },
        { txt: 'AR: 12,44' },
        { txt: 'Wingspan: 1320 mm' },
        { txt: 'Volume: 1116 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1550',
      price: 489,
      in_stock: false,
      image: require('@/assets/images/products/2025/wl1550.jpg'),
      description: 'The Leviathan 1550 front wing offers exceptional glide and lift, making it ideal for pumping and dock-start. It is perfect for flat water conditions and stand-up paddling.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 2140 cm2' },
        { txt: 'AR: 11,30' },
        { txt: 'Wingspan: 1550 mm' },
        { txt: 'Volume: 2757 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1750',
      price: 529,
      in_stock: false,
      image: require('@/assets/images/products/2025/wl1750.jpg'),
      description: 'The Leviathan 1750 front wing is designed for flat water conditions, offering exceptional efficiency in gliding and take-off. It is perfect for SUP foil enthusiasts.',
      disciplines: ['pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 2400 cm2' },
        { txt: 'AR: 12,70' },
        { txt: 'Wingspan: 1750 mm' },
        { txt: 'Volume: 3097 cm3' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
  ],
  // STABS ------------------------------
  stabs: [
    {
      name: 'SABFOIL Stab Blackbird Progressive 345',
      price: 349,
      deal_price: 314,
      in_stock: true,
      image: require('@/assets/images/products/2026/sp345bb.jpg'),
      description: 'Sabfoil Blackbird Progressive stabilizer 345 BB. Full carbon stabilizer designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'SP345/BB' },
        { txt: 'Surface 150cm2' },
        { txt: 'Span 345mm' },
        { txt: 'Root chord 64,4mm' },
        { txt: 'Aspect ratio 8,2' },
      ],
    },
    {
      name: 'SABFOIL Stab Blackbird Progressive 365',
      price: 349,
      deal_price: 314,
      in_stock: true,
      image: require('@/assets/images/products/2026/sp365bb.jpg'),
      description: 'Sabfoil Blackbird Progressive stabilizer 365 BB. Full carbon stabilizer designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'SP365/BB' },
        { txt: 'Surface 170cm2' },
        { txt: 'Span 365mm' },
        { txt: 'Root chord 68,3mm' },
        { txt: 'Aspect ratio 8,2' },
      ],
    },
    {
      name: 'SABFOIL Stab Blackbird Progressive 385',
      price: 349,
      deal_price: 314,
      in_stock: true,
      image: require('@/assets/images/products/2026/sp385bb.jpg'),
      description: 'Sabfoil Blackbird Progressive stabilizer 385 BB. Full carbon stabilizer designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'SP385/BB' },
        { txt: 'Surface 185cm2' },
        { txt: 'Span 385mm' },
        { txt: 'Root chord 71,2mm' },
        { txt: 'Aspect ratio 8,2' },
      ],
    },
    {
      name: 'SABFOIL Stab Blackbird Downwind 375 ',
      price: 349,
      deal_price: 314,
      in_stock: true,
      image: require('@/assets/images/products/2026/sdw375bb.jpg'),
      description: 'Blackbird Stabilizer 375 Downwind. Designed specifically for downwind and SUP foiling. Provides exceptional stability and control, enhancing glide and pumping efficiency for long-distance rides.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'SDW375/BB' },
      ],
    },
    {
      name: 'SABFOIL Stab Blackbird Blade 377',
      price: 349,
      in_stock: false,
      image: require('@/assets/images/products/2026/sb377bb.jpg'),
      description: 'Blackbird Stabilizer 377 Blade. Compact stabilizer designed for agility and control. Perfect for freestyle and wave riding, offering razor-sharp turns and responsive handling.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'SB377/BB' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 325 - 155cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sf325.jpg'),
      description: 'This stabilizer excels in maneuverability due to its flat profile and lack of winglets. It is hand sanded for a matte surface with 0-thickness graphics.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 155 cm2' },
        { txt: 'AR: 7,05' },
        { txt: 'Wingspan: 325 mm' },
        { txt: 'Chord: 58,9 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab IKA 330 - 217cm2',
      price: 249,
      deal_price: 75,
      in_stock: true,
      image: require('@/assets/images/products/stab_330.jpg'),
      description: 'Accessible et offrant une bonne stabilité. Certifié IKA Youth Foil Class.',
      disciplines: ['kite'],
      details: [
        { txt: 'S330' },
        { txt: 'Surface 217cm2' },
        { txt: 'Span 330mm' },
        { txt: 'Chord 80mm' },
        { txt: 'Aspect ratio 4,3' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 355 - 160cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sr355.jpg'),
      description: 'This stabilizer is designed for excellent performance in speed and directionality. It is ideal for carving.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 160 cm2' },
        { txt: 'AR: 8,08' },
        { txt: 'Wingspan: 360 mm' },
        { txt: 'Chord: 58,48 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 370 PF - 195cm2',
      price: 179,
      deal_price: 152,
      in_stock: true,
      image: require('@/assets/images/products/S370-PF_A.jpg'),
      description: 'Ce stab offre une grande maniabilité. Polyvalent, parfait dans toutes les disciplines, idéal pour carver.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'S370/PF' },
        { txt: 'Surface 195cm2' },
        { txt: 'Span 370mm' },
        { txt: 'Chord 67,5mm' },
        { txt: 'Aspect ratio 7,0' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 370 - 195cm2',
      price: 179,
      deal_price: 161,
      in_stock: true,
      image: require('@/assets/images/products/2025/sf370.jpg'),
      description: 'This stabilizer excels in maneuverability due to its flat profile and lack of winglets. It is hand sanded for a matte surface with 0-thickness graphics.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 195 cm2' },
        { txt: 'AR: 7,00' },
        { txt: 'Wingspan: 370 mm' },
        { txt: 'Chord: 67,5 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 375 PF - 178cm2',
      price: 179,
      deal_price: 152,
      in_stock: true,
      image: require('@/assets/images/products/S375-PF_A.jpg'),
      description: 'Excellentes performances en terme de vitesse et de manoeuvrabilité, et tout de même assez stable à haute vitesse.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'stab_375/PF' },
        { txt: 'Surface 178cm2' },
        { txt: 'Span 380mm' },
        { txt: 'Chord 61,72mm' },
        { txt: 'Aspect ratio 8,08' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 375 - 178cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sr375.jpg'),
      description: 'This stabilizer is designed for excellent performance in speed and directionality. It is ideal for carving.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 178 cm2' },
        { txt: 'AR: 8,08' },
        { txt: 'Wingspan: 380 mm' },
        { txt: 'Chord: 61,72 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Blade 377 - used',
      price: 199,
      deal_price: 149,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/2025/sb377.jpg'),
      description: 'Full carbon rear wing for high-speed freerace foiling. Fast profile, aggressive winglets, and T6 connection for maximum control. Perfect match with the Blade line. Occasion en parfait état, comme neuf!',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 177 cm2' },
        { txt: 'AR: 7,99' },
        { txt: 'Wingspan: 377 mm' },
        { txt: 'Chord: 61,5 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Blade 377 - 178cm2',
      price: 199,
      deal_price: 169,
      in_stock: true,
      image: require('@/assets/images/products/2025/sb377.jpg'),
      description: 'Full carbon rear wing for high-speed freerace foiling. Fast profile, aggressive winglets, and T6 connection for maximum control. Perfect match with the Blade line.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'Surface: 177 cm2' },
        { txt: 'AR: 7,99' },
        { txt: 'Wingspan: 377 mm' },
        { txt: 'Chord: 61,5 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 380 PF - 180cm2',
      price: 179,
      deal_price: 152,
      in_stock: true,
      image: require('@/assets/images/products/S380-PF_A.jpg'),
      description: 'Accessible et stable, le S380 offre aussi une belle glisse et il est plus rapide que son grand frère le S430',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'S380/PF' },
        { txt: 'Surface 180cm2' },
        { txt: 'Span 380mm' },
        { txt: 'Chord 60mm' },
        { txt: 'Aspect ratio 8,18 ' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 380 180cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sg380.jpg'),
      description: 'This stabilizer is ideal for increasing control and stability of the hydrofoil. The gullwing shape guarantees good directionality while riding.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'Surface: 180 cm2' },
        { txt: 'AR: 8,10' },
        { txt: 'Wingspan: 380 mm' },
        { txt: 'Chord: 60 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 395 PF - 198cm2',
      price: 179,
      deal_price: 152,
      in_stock: true,
      image: require('@/assets/images/products/S395-PF_A.jpg'),
      description: 'Excellentes performances en terme de vitesse et de manoeuvrabilité, et tout de même assez stable à haute vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S395/PF' },
        { txt: 'Surface 198cm2' },
        { txt: 'Span 400mm' },
        { txt: 'Chord 64,96mm' },
        { txt: 'Aspect ratio 8,08' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 395 - 198cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sr395.jpg'),
      description: 'This stabilizer is designed for excellent performance in speed and directionality. It is ideal for carving.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'Surface: 198 cm2' },
        { txt: 'AR: 8,08' },
        { txt: 'Wingspan: 400 mm' },
        { txt: 'Chord: 64,96 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab IKA 400 - 207cm2',
      price: 309,
      deal_price: 186,
      in_stock: true,
      image: require('@/assets/images/products/stab_400.jpg'),
      description: 'Le meilleure stab pour améliorer ses performances en vitesse, le S400 se révèle être très accessible, en offrant une glisse pure que rien ne freine. Certifié IKA 2020/2024.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S400' },
        { txt: 'Surface 207cm2' },
        { txt: 'Span 400mm' },
        { txt: 'Chord 64mm' },
        { txt: 'Aspect ratio 7,73' },
      ],
    },
    {
      name: 'MOSES Stab 425 - 259cm2',
      price: 269,
      deal_price: 134,
      deals_only: true,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/stab_425_havok.jpg'),
      description: 'Très stable et rapide, ce stab d’occasion est en bon état, malgré quelques rayures. \n Offrant beaucoup de lift, idéal pour un rider lourd.',
      disciplines: ['kite'],
      details: [
        { txt: 'S425 ("Havok")' },
        { txt: 'Surface 259cm2' },
        { txt: 'Span 425mm' },
        { txt: 'Chord 71,5mm' },
        { txt: 'Aspect ratio 6,97' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 425 - 266cm2',
      price: 279,
      deal_price: 153,
      in_stock: true,
      image: require('@/assets/images/products/stab_425.jpg'),
      description: 'Le S425 est un mix entre le S370 et le S483.' +
      ' Plus manoeuvrant et rapide que le S483, plus stable et offrant un meilleur lift que le S370.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'S425' },
        { txt: 'Surface 266cm2' },
        { txt: 'Span 425mm' },
        { txt: 'Chord 78mm' },
        { txt: 'Aspect ratio 6,8' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 430 240cm2',
      price: 179,
      in_stock: false,
      image: require('@/assets/images/products/2025/sg430.jpg'),
      description: 'This stabilizer is ideal for increasing control and stability of the hydrofoil. The gullwing shape guarantees good directionality while riding.',
      disciplines: ['kite', 'wing', 'wind', 'sup', 'dw'],
      details: [
        { txt: 'Surface: 240 cm2' },
        { txt: 'AR: 7,70' },
        { txt: 'Wingspan: 430 mm' },
        { txt: 'Chord: 68 mm' },
      ],
    },
    {
      name: 'SABFOIL Stab 450 - 326cm2',
      price: 299,
      deal_price: 149,
      in_stock: true,
      image: require('@/assets/images/products/stab_450.jpg'),
      description: 'Compatible avec les ailes avant de grande surface, ce stab procure une belle stabilité.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'S450' },
        { txt: 'Surface 326cm2' },
        { txt: 'Span 450mm' },
        { txt: 'Chord 85mm' },
        { txt: 'Aspect ratio 6,22' },
      ],
    },
    {
      name: 'SABFOIL Stab 483 - 316cm2',
      price: 309,
      deal_price: 155,
      in_stock: true,
      image: require('@/assets/images/products/stab_483.jpg'),
      description: 'Ce stab donne beaucoup de maniabilité aux grandes ailes avant, en leur permettant aussi d’aller vite. \n' +
      'Occasion en parfait état, très peu utilisé.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S483' },
        { txt: 'Surface 316cm2' },
        { txt: 'Span 483mm' },
        { txt: 'Chord 85mm' },
        { txt: 'Aspect ratio 7,6' },
      ],
    },
  ],
  // MASTS ------------------------------
  masts: [
    {
      name: 'SABFOIL Mast Blackbird 75 BB',
      price: 859,
      deal_price: 773,
      in_stock: true,
      image: require('@/assets/images/products/2026/m75bb.jpg'),
      description: 'Sabfoil Blackbird MastBlackbird mast in high-modulus carbon with W-Core technology. Race-optimized profile, extreme stiffness and instant reactivity for top performance in any condition.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'M75/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Mast Blackbird 85 BB',
      price: 869,
      deal_price: 782,
      in_stock: true,
      image: require('@/assets/images/products/2026/m85bb.jpg'),
      description: 'Sabfoil Blackbird mast 85 BB. Full carbon mast with UHM W-core. Designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'M85/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Mast Blackbird 95 BB',
      price: 879,
      deal_price: 791,
      in_stock: true,
      image: require('@/assets/images/products/2026/m95bb.jpg'),
      description: 'Sabfoil Blackbird mast 95 BB. Full carbon mast with UHM W-core. Designed for freestyle, wave and speed. Developed with Balz Müller for the Blackbird line.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'M95/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Mast Blackbird 110 BB',
      price: 899,
      in_stock: false,
      image: require('@/assets/images/products/2026/m110bb.jpg'),
      description: 'Sabfoil Blackbird Mast 110. Blackbird mast in high-modulus carbon with W-Core technology. Race-optimized profile, extreme stiffness and instant reactivity for top performance in any condition.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'M110/BB' },
        { txt: 'Bag and covers sold separately' },
      ],
    },
    {
      name: 'SABFOIL Kraken 73 Mast',
      price: 649,
      in_stock: false,
      image: require('@/assets/images/products/2025/mk73.jpg'),
      description: 'The Kraken 73 mast is optimized for maximum transversality across Wing-Foil, Surf-Foil, and Kite-Foil. It is robust and ideal for both speed and freestyle.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 730 mm' },
      ],
    },
    {
      name: 'SABFOIL Kraken 73P Mast',
      price: 649,
      in_stock: false,
      image: require('@/assets/images/products/2025/mk73p.jpg'),
      description: 'The Kraken 73P mast is optimized for maximum stiffness and great performance in pump foiling. It is versatile and suitable for many disciplines.',
      disciplines: ['wing', 'surf', 'pump', 'sup'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 730 mm' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83 Mast',
      price: 679,
      in_stock: false,
      image: require('@/assets/images/products/2025/mk83.jpg'),
      description: 'The Kraken 83 mast is optimized for maximum transversality across Wing-Foil, Surf-Foil, Kite-Foil, and Wind-Foil. It is robust and ideal for both speed and freestyle.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 830 mm' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83 Mast Balz Müller Limited',
      price: 699,
      deal_price: 629,
      in_stock: true,
      image: require('@/assets/images/products/2025/balzmk83.jpg'),
      description: 'The 83 cm-long carbon mast is optimized for maximum transversality between different disciplines. It is robust and performing, ideal for both speed and freestyle.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 830 mm' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83P Mast',
      price: 679,
      in_stock: false,
      image: require('@/assets/images/products/2025/mk83p.jpg'),
      description: 'The Kraken 83P mast is optimized for maximum stiffness and great performance in pump foiling. It is versatile and suitable for many disciplines.',
      disciplines: ['wing', 'surf', 'pump', 'sup'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 830 mm' },
      ],
    },
    {
      name: 'SABFOIL Kraken 93 PF Mast R8',
      price: 899,
      deal_price: 629,
      in_stock: true,
      image: require('@/assets/images/products/M93K-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'dw'],
      details: [
        { txt: 'M93K/PF' },
        { txt: 'Height 930mm' },
        { txt: 'Weight 1660g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 93 Mast',
      price: 699,
      in_stock: false,
      image: require('@/assets/images/products/2025/mk93.jpg'),
      description: 'The Kraken 93 mast is optimized for maximum transversality across Wing-Foil, Surf-Foil, Kite-Foil, and Wind-Foil. It is robust and ideal for both speed and freestyle.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'Full Carbon (with core)' },
        { txt: 'Conn. System: R8' },
        { txt: 'Height: 930 mm' },
      ],
    },
    {
      name: 'Q02K - Titanium Quick Release System',
      price: 79,
      deal_price: 71,
      in_stock: true,
      image: require('@/assets/images/products/Q02K.jpg'),
      description: 'Upgrade permettant de laisser plate (CP02K) ou tuttle (T04K) sur la planche et de connecter le mât rapidement avec une simple vis conique. \n Version en titane: résistance et design améliorés. ',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Q02K' },
        { txt: '1 x Titanium Pin' },
        { txt: '1 x Titanium Quick Release Module' },
        { txt: '2 x Default inox shims 6.1x14x0.5' },
        { txt: '1 x 6mm Hex Key' },
        { txt: '2 x Socket Head Cap Screws M6x30' },
        { txt: '20 x Adjustment inox shims 6.1x12x0.15' },
      ],
    },
    {
      name: 'Kraken Mast Plate',
      price: 199,
      deal_price: 89,
      in_stock: true,
      image: require('@/assets/images/products/mast_P02K.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de résistance. \n Possibilité d’upgrade avec le Quick Release System.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'P02K' },
        { txt: 'Weight 750g [±5%]' },
      ],
    },
    {
      name: 'Kraken Mast Plate - used',
      price: 199,
      deal_price: 69,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/mast_P02K.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de résistance. \n Possibilité d’upgrade avec le Quick Release System.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'P02K' },
        { txt: 'Weight 750g [±5%]' },
      ],
    },
    {
      name: 'Sabfoil Carbon Rail Plate (Titanium inserts)',
      price: 129,
      deal_price: 116,
      in_stock: true,
      image: require('@/assets/images/products/mast_CP02K_Ti.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de légéreté et de résistance. \n Possibilité d’upgrade avec le Quick Release System Titanium.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'CP02K/Ti' },
        { txt: 'Weight 485g [±5%]' },
      ],
    },
    {
      name: 'SABFOIL Mast 91Y Carbon',
      price: 879,
      deal_price: 439,
      in_stock: true,
      image: require('@/assets/images/products/mast_91.jpg'),
      description: 'Les mâts SABFOIL sont axés vers la performance et la maniabilité. \n IKA YOUTH FOIL CLASS.',
      disciplines: ['kite'],
      details: [
        { txt: 'M91Y' },
        { txt: 'Height 910mm' },
        { txt: 'Weight 1693g [±5%]' },
        { txt: 'Maximum thickness 13,50mm' },
      ],
    },
  ],
  // FUSELAGES --------------------------
  fuselages: [
    {
      name: 'SABFOIL Blackbird Backtail Alu Fuselage - Size L',
      price: 139,
      in_stock: false,
      image: require('@/assets/images/products/2026/fbbl.jpg'),
      description: 'Blackbird Backtail Fuselage Alu – Size L. High-strength aluminum rear fuselage compatible with all SABFOIL stabilizers. L version, 5 cm longer for enhanced pitch control and superior stability on the water.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'FBB/L' },
      ],
    },
    {
      name: 'SABFOIL Blackbird Backtail Alu Fuselage - Size M',
      price: 139,
      deal_price: 125,
      in_stock: true,
      image: require('@/assets/images/products/2026/fbbm.jpg'),
      description: 'Blackbird Backtail Fuselage Alu – Size M. High-strength aluminum rear fuselage compatible with all SABFOIL stabilizers. M version, same length of Blackbird Carbon stabs, for enhanced modularity and retro-compatibility.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'FBB/M' },
      ],
    },
    {
      name: 'SABFOIL Blackbird Backtail Alu Fuselage - Size S',
      price: 139,
      in_stock: false,
      image: require('@/assets/images/products/2026/fbbs.jpg'),
      description: 'Blackbird Backtail Fuselage Alu – Size S. High-strength aluminum rear fuselage, 5 cm shorter for maximum agility and instant response. Perfect for freestyle, wave, prone surf, and efficient downwind pumping.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'FBB/S' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 603 T6 KMS',
      price: 199,
      deal_price: 179,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_603K.jpg'),
      description: 'Fuselage de 603mm extrêmement résistant. \n Pour les petites ailes avant à la corde (T6; vis M6). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'F603K' },
        { txt: 'Weight 690g [±5%]' },
        { txt: 'Front wing connection type T6' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 603 T6 KMS used',
      price: 199,
      deal_price: 159,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/fuselage_603K.jpg'),
      description: 'Fuselage de 603mm extrêmement résistant. \n Pour les petites ailes avant à la corde (T6; vis M6). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance. Occasion en parfait état, comme neuf!',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'F603K' },
        { txt: 'Weight 690g [±5%]' },
        { txt: 'Front wing connection type T6' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 653 T6 KMS',
      price: 199,
      deal_price: 179,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_653K.jpg'),
      description: 'Fuselage de 653mm extrêmement résistant. \n Pour les petites ailes avant à la corde (T6; vis M6). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'F653K' },
        { txt: 'Weight 750g [±5%]' },
        { txt: 'Front wing connection type T6' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 663 T8 KMS',
      price: 199,
      deal_price: 179,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_663K.jpg'),
      description: 'Fuselage de 663mm extrêmement résistant. \n Pour les grandes ailes avant à la corde (T8; vis M8). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf', 'pump'],
      details: [
        { txt: 'F663K' },
        { txt: 'Weight g [±5%]' },
        { txt: 'Front wing connection type T8' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 703 T8 KMS',
      price: 199,
      deal_price: 179,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_703K.jpg'),
      description: 'Fuselage de 703mm extrêmement résistant. \n Pour les grandes ailes avant à la corde (T8; vis M8). \n Avec le système modulable Kraken tous les mâts et fuselages sont compatibles entre eux. \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'F703K' },
        { txt: 'Weight 900g [±5%]' },
        { txt: 'Front wing connection type T8' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 899-HS',
      price: 389,
      deal_price: 194,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_899.jpg'),
      description: 'Alliage aluminium/manganèse extrêmement résistant. Pour le windsurf.',
      disciplines: ['wind'],
      details: [
        { txt: 'F899-HS' },
      ],
    },
  ],
};

Object.entries(allProducts).forEach((entry) => {
  const products = entry[1];

  products.forEach((product) => {
    Object.assign(product, {
      // create a uid from the product's name
      uid: product.name.replaceAll(' - ', ' ').replaceAll(' ', '_').replaceAll('/', '-').toLowerCase(),
    });
  });
});

const store = new Vuex.Store({
  state: {
    all_products: allProducts,
    all_disciplines: allDisciplines,
    cartProducts: [],
    showModal: false,
    showPopupCart: false,
  },

  getters: {
    getDisciplines: state => () => state.all_disciplines,
    getProducts: state => (category, discipline) => {
      // get all products
      let products = Object.values(state.all_products)
        .reduce((prod, p) => prod.concat(p), []);

      if (category.includes('deals')) {
        // take only products with that have special deals
        products = products.filter(p => p.deal_price);
      } else {
        if (category && state.all_products[category]) {
          products = state.all_products[category];
        }

        // remove items that should only appear in deals tab
        products = products.filter(p => p.deals_only === undefined || p.deals_only === false);
      }

      if (discipline) {
        products = products.filter(p => p.disciplines.includes(discipline));
      }

      return products;
    },
    getProductFromUid: state => (uid) => {
      const allTheProducts = Object.values(state.all_products)
        .reduce((prod, p) => prod.concat(p), []);
      const matchingProducts = allTheProducts.filter(p => p.uid === uid);
      return matchingProducts[0];
    },
    getProductsInCart: state => state.cartProducts,
    getShowModal: state => state.showModal,
    getPopupCart: state => state.showPopupCart,
  },

  mutations: {
    ADD_PRODUCT: (state, product) => {
      state.cartProducts.push(product);
    },
    REMOVE_PRODUCT: (state, product) => {
      state.cartProducts.splice(product, 1);
    },
    SHOW_MODAL: (state) => {
      state.showModal = !state.showModal;
    },
    SHOW_POPUP_CART: (state) => {
      state.showPopupCart = !state.showPopupCart;
    },
  },

  actions: {
    addProduct: (context, product) => {
      context.commit('ADD_PRODUCT', product);
    },
    removeProduct: (context, product) => {
      context.commit('REMOVE_PRODUCT', product);
    },
    showOrHiddenModal: (context) => {
      context.commit('SHOW_MODAL');
    },
    showOrHiddenPopupCart: (context) => {
      context.commit('SHOW_POPUP_CART');
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js